interface Props {
  onStay: () => void;
}

export function InactivityBanner({ onStay }: Props) {
  return (
    <div
      role="alert"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3
                 bg-yellow-50 border border-yellow-300 text-yellow-900
                 rounded-xl px-5 py-3 shadow-xl text-sm whitespace-nowrap"
    >
      <span className="material-symbols-outlined text-yellow-600 text-xl flex-shrink-0">timer</span>
      <p>
        You'll be signed out in <strong>30 seconds</strong> due to inactivity.
      </p>
      <button
        onClick={onStay}
        className="ml-1 px-3 py-1 bg-yellow-200 hover:bg-yellow-300 rounded-lg
                   font-semibold transition-colors text-xs flex-shrink-0"
      >
        Stay signed in
      </button>
    </div>
  );
}
